import React, { useCallback } from 'react';
import Text from 'components/Text/Text';
import { Form, Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

interface IProps {
	toggleOpenPrice: (value: boolean) => void;
	hasOpenPrice: boolean;
}

export const HasOpenPrice: React.FC<IProps> = ({ toggleOpenPrice, hasOpenPrice }) => {
	const handleChange = useCallback((e: CheckboxChangeEvent) => toggleOpenPrice(e.target.checked), [toggleOpenPrice]);

	return (
		<Form.Item name="hasOpenPrice">
			<Checkbox checked={hasOpenPrice} onChange={handleChange}>
				<Text translationNameSpace="form" translationKey="openPriceLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};
